import { render, staticRenderFns } from "./ReadMoreCollapse.vue?vue&type=template&id=059e9fac&"
import script from "./ReadMoreCollapse.vue?vue&type=script&lang=ts&"
export * from "./ReadMoreCollapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports